import { FC, useState } from "react";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/ru_RU";

import styles from "./IRangePicker.module.scss";
import { CloseIco, DatePickerIco } from "../../assets/customIcons";
import FormFieldWrapper from "../FormField/FormFieldWrapper";
import classNames from "classnames";
import IMask from "imask";
import moment from "moment";

const { RangePicker } = DatePicker;

interface IRangePickerProps {
  className?: string;
  error?: string;
  label?: string;
  field?: any;
  disabled?: boolean;
  isRequired?: boolean;
  isFocused?: boolean;
  format?: string;
  picker?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: any) => void;
}

export const IRangePicker: FC<IRangePickerProps> = ({
  className,
  error,
  label,
  field,
  disabled,
  isRequired,
  isFocused,
  format = "DD.MM.YYYY",
  picker,
  onFocus,
  onBlur,
  onChange,
}) => {
  const [focus, setIsFocus] = useState(false);

  const onInputFocus = (e) => {
    setIsFocus(true);

    if (typeof onFocus === "function") {
      onFocus(e);
    }
  };

  const onInputBlur = (e) => {

    setIsFocus(false);
    if (typeof onBlur === "function") {
      onBlur(e);
    }
  };
  const hasValues = !!field.value;
  const onChangeFunc = (value) => {
    field?.onChange(value);
    if (typeof onChange === "function") {
      onChange(value);
    }
  };

  return (
    <FormFieldWrapper
      error={error}
      label={label}
      required={isRequired}
      disabled={disabled}
      isFocused={focus || isFocused || hasValues}
      className={classNames(styles.textField, {
        [className]: className,
        [styles.noLabel]: !label,
      })}
    >
      <RangePicker
        {...field}
        allowClear
        className={classNames(styles.input, {
          [styles.error]: error,
          [styles.active]: focus || isFocused,
        })}
        locale={locale}
        format={format}
        allowEmpty={[true, true]}
        suffixIcon={<DatePickerIco />}
        clearIcon={<CloseIco />}
        separator={null}
        placeholder={["", ""]}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        onChange={onChangeFunc}
        disabled={disabled}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
          const key = event.key;
          if (key === "Backspace" || key === "Delete") {
            return;
          }
          const input = event.target as HTMLInputElement;
          const curValue = input.value;

          if (curValue.length === 10) {
            event.preventDefault();
            return;
          }

          if (key < "0" || key > "9") {
            event.preventDefault();
            return;
          }

          let newValue = "";
          switch (curValue.length) {
            case 2:
            case 5:
              newValue = curValue + ".";
              break;
            default:
              newValue = curValue;
          }

          input.value = newValue;
        }}
      />
    </FormFieldWrapper>
  );
};
